import '../styles/about.css';

const AboutSection = () => {
  return (
    <section className="about" id="about">
      <div className="container">
        <div className="about-grid">
          <div className="about-left animate-on-scroll animate-slide-left">
            <span className="section-tag">🇿🇲 About Us</span>
            <h2 className="section-title" style={{ textAlign: "left" }}>Built in Zambia,<br />for Zambia</h2>
            <p className="about-desc">
              ZamWheelz was founded with a simple mission: make buying and selling vehicles in Zambia transparent, safe, and accessible to everyone.
            </p>
            <p className="about-desc">
              We built both the iOS and Android apps from the ground up, designed for the real Zambian experience: local currency, local cities, and local trust.
            </p>
            <div className="about-mini-stats">
              <div className="about-mini-stat">
                <strong>2024</strong>
                <span>Founded in Lusaka</span>
              </div>
              <div className="about-mini-stat">
                <strong>iOS + Android</strong>
                <span>Native apps, built for Africa</span>
              </div>
            </div>
          </div>
          <div className="about-right animate-on-scroll animate-slide-right">
            <div className="about-flag">🇿🇲</div>
            <h3>Made with ❤️ in Zambia</h3>
            <p>Every feature is designed for the way Zambians buy and sell, from Kwacha pricing to city-based search to NRC verification.</p>
            <div className="about-stats-row">
              {[
                { val: "20K+", label: "Listings" },
                { val: "15K+", label: "Users" },
                { val: "10+", label: "Cities" },
              ].map((s) => (
                <div className="about-stat" key={s.label}>
                  <strong>{s.val}</strong>
                  <span>{s.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;